module.exports = __webpack_public_path__ + "img/down-logo.03a64604.png";